import { type ReactNode } from 'react';
import { forwardRef } from 'react';
import {
    type IFloatingFilterParams,
    type INumberFilterParams,
} from '@ag-grid-community/core';
import NumberFilter from './NumberFilter';
import PatternFilter from './PatternFilter';

function CustomNumberFilterComponent(
    props: IFloatingFilterParams,
    ref,
): ReactNode {
    const allowedCharPattern: string | undefined = (
        props.filterParams as INumberFilterParams
    ).allowedCharPattern;

    const isCustomPattern = Boolean(allowedCharPattern);

    return isCustomPattern ? (
        <PatternFilter {...props} />
    ) : (
        <NumberFilter {...props} />
    );
}

const CustomNumberFilter = forwardRef(CustomNumberFilterComponent);

export default CustomNumberFilter;
